import { render, staticRenderFns } from "./VideoSelect.vue?vue&type=template&id=7a8e63a8&scoped=true&"
import script from "./VideoSelect.vue?vue&type=script&lang=js&"
export * from "./VideoSelect.vue?vue&type=script&lang=js&"
import style0 from "./VideoSelect.vue?vue&type=style&index=0&id=7a8e63a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8e63a8",
  null
  
)

export default component.exports